document.addEventListener( 'DOMContentLoaded', () => {

	const pageHeader = document.querySelector( '.page-header' );
	const pageHeaderInner = document.querySelector( '.page-header__inner' );
	const nav  = document.querySelector( '.page-header__nav' );
	const navName = document.querySelector( '.page-header__toggle--name' );
	const menuToggle = document.querySelector( '.page-header__toggle' );
	const isDark = pageHeader.classList.contains( 'page-header--dark' );
	let animating = false;
	let headerHeight = pageHeaderInner.offsetHeight;


	/**
	 * Adds the 'page-header--dark' class to the header if the current page is dark themed.
	 */
	const setDarkVersion = () => {

		if ( isDark ) {

			pageHeader.classList.add( 'page-header--dark' );
			document.body.style.paddingTop = `0px`;

		}

	};

	setDarkVersion();

	pageHeaderInner.addEventListener( 'animationend', () => {

		setTimeout( () => {

			pageHeaderInner.classList.remove( 'page-header__animation' );

		}, 250 );

	} );
	if ( menuToggle ) {

		menuToggle.classList.add( '--init' );
		setTimeout( () => {

			menuToggle.classList.remove( '--init' );

		}, 220 );

		menuToggle.addEventListener( 'click', () => {

			if ( animating ) {

				return;

			}
			animating = true;

			if ( menuToggle.classList.contains( 'page-header__toggle--open' ) ) {

				menuToggle.classList.add( 'page-header__toggle--closing' );
				nav.classList.add( 'page-header__nav--closing' );

				if( isDark ){

					pageHeader.classList.remove( 'page-header--white' );

				}

				setTimeout( () => {

					menuToggle.classList.remove( 'page-header__toggle--open' );
					menuToggle.classList.remove( 'page-header__toggle--closing' );
					nav.classList.remove( 'page-header__nav--open' );
					nav.classList.remove( 'page-header__nav--closing' );
					menuToggle.setAttribute( 'aria-expanded', 'false' );
					navName.textContent = navName.getAttribute( 'data-name-close' );
					animating = false;



				}, 300 );

			} else {

				if( isDark ){

					pageHeader.classList.add( 'page-header--white' );

				}
				menuToggle.classList.add( 'page-header__toggle--open' );
				nav.classList.add( 'page-header__nav--open' );
				menuToggle.setAttribute( 'aria-expanded', 'true' );
				navName.textContent = navName.getAttribute( 'data-name-open' );
				setTimeout( () => {

					animating = false;

				}, 300 );

			}


		} );

	}

	/**
	 * Sets or removes the top padding of the document body based on the header's height.
	 *
	 * @param {boolean} add - If true, adds padding equal to the header's height to the body; if false, removes the padding.
	 */
	const setBodyPadding = ( add ) => {

		if( !isDark ) {

			if ( add ) {

				document.body.style.paddingTop = `${headerHeight  }px`;

			} else {

				document.body.style.paddingTop = '';

			}

		}

	};

	setBodyPadding( true );

	const observer = new IntersectionObserver(
		( entries ) => {

			entries.forEach( entry => {

				if ( !entry.isIntersecting ) {

					headerHeight = pageHeaderInner.offsetHeight;
					pageHeaderInner.classList.add( 'page-header--is-sticky' );
					setBodyPadding( true );
					if( isDark ){

						pageHeader.classList.remove( 'page-header--dark' );

					}

				} else {

					pageHeaderInner.classList.remove( 'page-header--is-sticky' );

					if( isDark ){

						pageHeader.classList.add( 'page-header--dark' );

					}

				}


			} );

		},
		{
			root: null,
			threshold: 0.5,
			//rootMargin: "-110px 0px 0px 0px"
		}
	);

	observer.observe( pageHeader );


} );